// extracted by mini-css-extract-plugin
export default {"wrapper":"Loading_wrapper__bPu6n","preloader":"Loading_preloader__V-6If","upDown":"Loading_upDown__iP3AW"};